import { render } from "./index.vue?vue&type=template&id=18d3d61d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=18d3d61d&lang=less&scoped=true"

import exportComponent from "/builds/ChinaApplicationPool/dia/smart-search/mobile-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d3d61d"]])

export default __exports__